export enum PermissionType {
  Search = 1,
  Create = 2,
  Read = 3,
  Update = 4,
  Delete = 5,
}
